module.exports = /******/ (function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/ var installedModules = {};
  /******/
  /******/ // The require function
  /******/ function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/ if (installedModules[moduleId]) {
      /******/ return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = (installedModules[moduleId] = {
      /******/ i: moduleId,
      /******/ l: false,
      /******/ exports: {},
      /******/
    });
    /******/
    /******/ // Execute the module function
    /******/ modules[moduleId].call(
      module.exports,
      module,
      module.exports,
      __webpack_require__
    );
    /******/
    /******/ // Flag the module as loaded
    /******/ module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/ return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/ __webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/ __webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/ __webpack_require__.d = function (exports, name, getter) {
    /******/ if (!__webpack_require__.o(exports, name)) {
      /******/ Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter,
      });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/ __webpack_require__.r = function (exports) {
    /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
      /******/ Object.defineProperty(exports, Symbol.toStringTag, {
        value: "Module",
      });
      /******/
    }
    /******/ Object.defineProperty(exports, "__esModule", { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/ __webpack_require__.t = function (value, mode) {
    /******/ if (mode & 1) value = __webpack_require__(value);
    /******/ if (mode & 8) return value;
    /******/ if (
      mode & 4 &&
      typeof value === "object" &&
      value &&
      value.__esModule
    )
      return value;
    /******/ var ns = Object.create(null);
    /******/ __webpack_require__.r(ns);
    /******/ Object.defineProperty(ns, "default", {
      enumerable: true,
      value: value,
    });
    /******/ if (mode & 2 && typeof value != "string")
      for (var key in value)
        __webpack_require__.d(
          ns,
          key,
          function (key) {
            return value[key];
          }.bind(null, key)
        );
    /******/ return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/ __webpack_require__.n = function (module) {
    /******/ var getter =
      module && module.__esModule
        ? /******/ function getDefault() {
            return module["default"];
          }
        : /******/ function getModuleExports() {
            return module;
          };
    /******/ __webpack_require__.d(getter, "a", getter);
    /******/ return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/ __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/ __webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/ return __webpack_require__((__webpack_require__.s = 91));
  /******/
})(
  /************************************************************************/
  /******/ {
    /***/ 0: /***/ function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */ __webpack_require__.d(
        __webpack_exports__,
        "a",
        function () {
          return normalizeComponent;
        }
      );
      /* globals __VUE_SSR_CONTEXT__ */

      // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
      // This module is a runtime utility for cleaner component module output and will
      // be included in the final webpack user bundle.

      function normalizeComponent(
        scriptExports,
        render,
        staticRenderFns,
        functionalTemplate,
        injectStyles,
        scopeId,
        moduleIdentifier /* server only */,
        shadowMode /* vue-cli only */
      ) {
        // Vue.extend constructor export interop
        var options =
          typeof scriptExports === "function"
            ? scriptExports.options
            : scriptExports;

        // render functions
        if (render) {
          options.render = render;
          options.staticRenderFns = staticRenderFns;
          options._compiled = true;
        }

        // functional template
        if (functionalTemplate) {
          options.functional = true;
        }

        // scopedId
        if (scopeId) {
          options._scopeId = "data-v-" + scopeId;
        }

        var hook;
        if (moduleIdentifier) {
          // server build
          hook = function (context) {
            // 2.3 injection
            context =
              context || // cached call
              (this.$vnode && this.$vnode.ssrContext) || // stateful
              (this.parent &&
                this.parent.$vnode &&
                this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
              context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyles) {
              injectStyles.call(this, context);
            }
            // register component module identifier for async chunk inferrence
            if (context && context._registeredComponents) {
              context._registeredComponents.add(moduleIdentifier);
            }
          };
          // used by ssr in case component is cached and beforeCreate
          // never gets called
          options._ssrRegister = hook;
        } else if (injectStyles) {
          hook = shadowMode
            ? function () {
                injectStyles.call(this, this.$root.$options.shadowRoot);
              }
            : injectStyles;
        }

        if (hook) {
          if (options.functional) {
            // for template-only hot-reload because in that case the render fn doesn't
            // go through the normalizer
            options._injectStyles = hook;
            // register for functioal component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
              hook.call(context);
              return originalRender(h, context);
            };
          } else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing
              ? [].concat(existing, hook)
              : [hook];
          }
        }

        return {
          exports: scriptExports,
          options: options,
        };
      }

      /***/
    },

    /***/ 29: /***/ function (module, exports) {
      module.exports = require("element-ui/lib/tooltip");

      /***/
    },

    /***/ 36: /***/ function (
      module,
      __webpack_exports__,
      __webpack_require__
    ) {
      "use strict";
      /* harmony default export */ __webpack_exports__["a"] = {
        inject: ["rootMenu"],
        computed: {
          indexPath: function indexPath() {
            var path = [this.index];
            var parent = this.$parent;
            while (parent.$options.componentName !== "ElMenu") {
              if (parent.index) {
                path.unshift(parent.index);
              }
              parent = parent.$parent;
            }
            return path;
          },
          parentMenu: function parentMenu() {
            var parent = this.$parent;
            while (
              parent &&
              ["ElMenu", "ElSubmenu"].indexOf(parent.$options.componentName) ===
                -1
            ) {
              parent = parent.$parent;
            }
            return parent;
          },
          paddingStyle: function paddingStyle() {
            if (this.rootMenu.mode !== "vertical") return {};

            var padding = 20;
            var parent = this.$parent;

            if (this.rootMenu.collapse) {
              padding = 20;
            } else {
              while (parent && parent.$options.componentName !== "ElMenu") {
                if (parent.$options.componentName === "ElSubmenu") {
                  padding += 20;
                }
                parent = parent.$parent;
              }
            }
            return { paddingLeft: padding + "px" };
          },
        },
      };

      /***/
    },

    /***/ 4: /***/ function (module, exports) {
      module.exports = require("element-ui/lib/mixins/emitter");

      /***/
    },

    /***/ 91: /***/ function (
      module,
      __webpack_exports__,
      __webpack_require__
    ) {
      "use strict";
      __webpack_require__.r(__webpack_exports__);

      // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=template&id=2a5dbfea&
      var render = function () {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c(
          "li",
          {
            staticClass: "el-menu-item",
            class: {
              "is-active": _vm.active,
              "is-disabled": _vm.disabled,
            },
            style: [
              _vm.paddingStyle,
              _vm.itemStyle,
              { backgroundColor: _vm.backgroundColor },
            ],
            attrs: { role: "menuitem", tabindex: "-1" },
            on: {
              click: _vm.handleClick,
              mouseenter: _vm.onMouseEnter,
              focus: _vm.onMouseEnter,
              blur: _vm.onMouseLeave,
              mouseleave: _vm.onMouseLeave,
            },
          },
          [
            _vm.parentMenu.$options.componentName === "ElMenu" &&
            _vm.rootMenu.collapse &&
            _vm.$slots.title
              ? _c(
                  "el-tooltip",
                  {
                    attrs: {
                      effect: "dark",
                      placement: "right",
                      "popper-class": "menu-tip",
                      // value: true,
                    },
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "content" }, slot: "content" },
                      [_vm._t("title")],
                      2
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          position: "absolute",
                          left: "0",
                          top: "0",
                          height: "100%",
                          width: "100%",
                          display: "inline-block",
                          "box-sizing": "border-box",
                          padding: "0 20px",
                        },
                      },
                      [_vm._t("default")],
                      2
                    ),
                  ]
                )
              : [_vm._t("default"), _vm._t("title")],
          ],
          2
        );
      };
      var staticRenderFns = [];
      render._withStripped = true;

      // CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=template&id=2a5dbfea&

      // EXTERNAL MODULE: ./packages/menu/src/menu-mixin.js
      var menu_mixin = __webpack_require__(36);

      // EXTERNAL MODULE: external "element-ui/lib/tooltip"
      var tooltip_ = __webpack_require__(29);
      var tooltip_default = /*#__PURE__*/ __webpack_require__.n(tooltip_);

      // EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
      var emitter_ = __webpack_require__(4);
      var emitter_default = /*#__PURE__*/ __webpack_require__.n(emitter_);

      // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //

      /* harmony default export */ var menu_itemvue_type_script_lang_js_ = {
        name: "ElMenuItem",

        componentName: "ElMenuItem",

        mixins: [menu_mixin["a" /* default */], emitter_default.a],

        components: { ElTooltip: tooltip_default.a },

        props: {
          index: {
            default: null,
            validator: function validator(val) {
              return typeof val === "string" || val === null;
            },
          },
          route: [String, Object],
          disabled: Boolean,
        },
        computed: {
          active: function active() {
            return this.index === this.rootMenu.activeIndex;
          },
          hoverBackground: function hoverBackground() {
            return this.rootMenu.hoverBackground;
          },
          backgroundColor: function backgroundColor() {
            return this.rootMenu.backgroundColor || "";
          },
          activeTextColor: function activeTextColor() {
            return this.rootMenu.activeTextColor || "";
          },
          textColor: function textColor() {
            return this.rootMenu.textColor || "";
          },
          mode: function mode() {
            return this.rootMenu.mode;
          },
          itemStyle: function itemStyle() {
            var style = {
              color: this.active ? this.activeTextColor : this.textColor,
            };
            if (this.mode === "horizontal" && !this.isNested) {
              style.borderBottomColor = this.active
                ? this.rootMenu.activeTextColor
                  ? this.activeTextColor
                  : ""
                : "transparent";
            }
            return style;
          },
          isNested: function isNested() {
            return this.parentMenu !== this.rootMenu;
          },
        },
        methods: {
          onMouseEnter: function onMouseEnter() {
            if (this.mode === "horizontal" && !this.rootMenu.backgroundColor)
              return;
            this.$el.style.backgroundColor = this.hoverBackground;
          },
          onMouseLeave: function onMouseLeave() {
            if (this.mode === "horizontal" && !this.rootMenu.backgroundColor)
              return;
            this.$el.style.backgroundColor = this.backgroundColor;
          },
          handleClick: function handleClick() {
            if (!this.disabled) {
              this.dispatch("ElMenu", "item-click", this);
              this.$emit("click", this);
            }
          },
        },
        mounted: function mounted() {
          this.parentMenu.addItem(this);
          this.rootMenu.addItem(this);
        },
        beforeDestroy: function beforeDestroy() {
          this.parentMenu.removeItem(this);
          this.rootMenu.removeItem(this);
        },
      };
      // CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
      /* harmony default export */ var src_menu_itemvue_type_script_lang_js_ =
        menu_itemvue_type_script_lang_js_;
      // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
      var componentNormalizer = __webpack_require__(0);

      // CONCATENATED MODULE: ./packages/menu/src/menu-item.vue

      /* normalize component */

      var component = Object(componentNormalizer["a" /* default */])(
        src_menu_itemvue_type_script_lang_js_,
        render,
        staticRenderFns,
        false,
        null,
        null,
        null
      );

      /* hot reload */
      if (false) {
        var api;
      }
      component.options.__file = "packages/menu/src/menu-item.vue";
      /* harmony default export */ var menu_item = component.exports;
      // CONCATENATED MODULE: ./packages/menu-item/index.js

      /* istanbul ignore next */
      menu_item.install = function (Vue) {
        Vue.component(menu_item.name, menu_item);
      };

      /* harmony default export */ var packages_menu_item =
        (__webpack_exports__["default"] = menu_item);

      /***/
    },

    /******/
  }
);
